import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import TourManagementOptionsSidebar from "../components/tour/TourManagementSidebarOptionsSidebar";
import TourManagementAvailabilityHeader from "../components/TourManagementAvailabilityHeader";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { setOptionsData, setPackageData } from "../reducer/tourReducer";
import CustomRadio from "../components/common/CustomRadio";
import { useOptions } from "../hooks/useOptions";
import { resetOptionEdit } from "../reducer/tourEditReducer";

function TourManagementPackageAvailabilityCapacityPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { packageData, PrepackageDataId, optionsData, packageId } = useSelector(
    (state: RootState) => state.tour
  );
  const {
    tourEdit,
    optionId,
    id: editPackageId,
  } = useSelector((state: RootState) => state.edit);
  const progressref = useRef(17);

  useEffect(() => {
    if (location.state && location.state.optionData) {
      dispatch(setOptionsData(location.state.optionData));
    }
  }, [location.state, dispatch]);

  const [loading, setLoading] = useState(false);
  const { createPreOptions } = useOptions();
  const [editedMinParticipants, setEditedMinParticipants] = useState<any>(
    optionsData.minParticipants || 0
  );
  const [editedMaxParticipants, setEditedMaxParticipants] = useState(
    optionsData.maxParticipants || 0
  );
  const [editedUpdatedMaxParticipants, setEditedUpdatedMaxParticipants] =
    useState(optionsData?.expectedMaxParticipants || 0);
  const [editedCapacityExpectation, setEditedCapacityExpectation] = useState(
    optionsData?.expectedParticipants || false
  );

  useOnLoadPage({ tabActive: "create" });

  const onContinue = async () => {
    const updatedPackageData = {
      ...optionsData,
      id: optionsData._id,
      progress: Number(progressref.current),
      expectedParticipants:
        editedCapacityExpectation ?? optionsData.expectedParticipants,
      minParticipants: editedMinParticipants || optionsData.minParticipants,
      maxParticipants: editedMaxParticipants || optionsData.maxParticipants,
      expectedMaxParticipants:
        editedUpdatedMaxParticipants || optionsData.expectedMaxParticipants,
    };

    dispatch(setOptionsData(updatedPackageData));

    const updatedPackageData2 = {
      ...optionsData,
      ...updatedPackageData,
    };

    setLoading(true);

    try {
      if (tourEdit) {
        dispatch(resetOptionEdit());
        dispatch(setOptionsData(updatedPackageData2));
        const pkgId = packageData._id;
        navigate(`/manage/product/${pkgId}/${optionId}`, {
          state: {
            fromEdit: true,
            option: updatedPackageData2,
            packageId: pkgId,
          },
        });
        return;
      } else {
        await createPreOptions(updatedPackageData);
      }
      navigate(Paths.tourManagementPackageOptionsAvailabilityPrice);
    } catch (error) {
      console.error("Error saving package:", error);
    } finally {
      setLoading(false);
    }
  };

  // const onContinue = () => {
  //   navigate(Paths.tourManagementPackageOptionsAvailabilityPrice);
  // };

  const handleBack = () => {
    navigate(-1);
  };

  console.log("package", optionsData);

  return (
    <div className={Classname.container}>
      <Navbar />
      <div className={Classname.content}>
        <TourManagementOptionsSidebar selected={4} />
        <div className={Classname.detail}>
          <TourManagementAvailabilityHeader active={2} />
          <div className={Classname.title}>
            Now, let’s look at your capacity
          </div>
          {optionsData.priceByGroup ? (
            <>
              <div className={Classname.title2}>
                What’s the maximum number of groups you can take per time slot?
              </div>
              <div className="flex items-center gap-8">
                <div>Max # of Group</div>
                <input
                  type="number"
                  className={Classname.input}
                  value={editedUpdatedMaxParticipants}
                  onChange={(e) => {
                    const value = Math.abs(parseInt(e.target.value));
                    setEditedUpdatedMaxParticipants(value);
                    dispatch(
                      setOptionsData({
                        ...optionsData,
                        expectedMaxParticipants: value,
                      })
                    );
                  }}
                />
              </div>
            </>
          ) : (
            <>
              <div className={Classname.title2}>
                How many participants can you take per time slot?
              </div>
              <div className="flex items-center gap-9 mb-2">
                <div>Min # of participants</div>
                <input
                  type="number"
                  className={Classname.input}
                  value={editedMinParticipants}
                  onChange={(e) => {
                    const value = Math.abs(parseInt(e.target.value));
                    setEditedMinParticipants(value);
                    dispatch(
                      setOptionsData({
                        ...optionsData,
                        minParticipants: value,
                      })
                    );
                  }}
                />
              </div>
              <div className="flex items-center gap-8">
                <div>Max # of participants</div>
                <input
                  type="number"
                  className={Classname.input}
                  value={editedMaxParticipants}
                  onChange={(e) => {
                    const value = Math.abs(parseInt(e.target.value));
                    setEditedMaxParticipants(value);
                    dispatch(
                      setOptionsData({
                        ...optionsData,
                        maxParticipants: value,
                      })
                    );
                  }}
                />
              </div>
              <div className={Classname.title2}>
                Do your exceptions share the same capacity?
              </div>
              <CustomRadio
                value={false}
                label="Yes all my expectations have the same capacity"
                selected={editedCapacityExpectation}
                onSelect={(value) => {
                  setEditedCapacityExpectation(value);
                  dispatch(
                    setOptionsData({
                      ...optionsData,
                      expectedParticipants: value,
                    })
                  );
                }}
              />
              <CustomRadio
                value={true}
                label="No, my expectations have a different capacity"
                selected={editedCapacityExpectation}
                onSelect={(value) => {
                  setEditedCapacityExpectation(value);
                  dispatch(
                    setOptionsData({
                      ...optionsData,
                      expectedParticipants: value,
                    })
                  );
                }}
              />

              <div>
                {editedCapacityExpectation === true && (
                  <div className="w-full border-2 border-gray-200 p-6 mt-7 rounded-xl">
                    <p className="text-lg lg:text-2xl font-bold my-3">
                      Change the capacity for your expectations
                    </p>
                    <p className="mb-7">
                      How many participants can you take on these days?
                    </p>

                    <div className="flex items-center gap-8">
                      <div>Max # of participants</div>
                      <input
                        type="number"
                        className={Classname.input}
                        value={editedUpdatedMaxParticipants}
                        onChange={(e) => {
                          const value = Math.abs(parseInt(e.target.value));
                          setEditedUpdatedMaxParticipants(value);
                          dispatch(
                            setOptionsData({
                              ...optionsData,
                              expectedMaxParticipants: value,
                            })
                          );
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
          <div className={Classname.buttonsContainer}>
            <button className={Classname.saveButton} onClick={handleBack}>
              Back
            </button>
            <button className={Classname.continueButton} onClick={onContinue}>
              Save and {!tourEdit ? "Continue" : "Exit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TourManagementPackageAvailabilityCapacityPage;

const Classname = {
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 lg:px-6 w-full",
  title: "font-bold text-lg mt-6 mb-2",
  title2: "font-bold lg:text-lg mt-6 mb-2",
  input: "flex w-24 h-8 border border-gray-300 rounded-sm px-4 mt-2",
  textarea:
    "flex w-full h-44 py-4 border border-gray-400 rounded-md px-4 mt-2 mb-6",
  description: "flex text-base mb-4",
  buttonsContainer: "flex flex-1 justify-between lg:justify-end gap-3 mt-10",
  highlightButton:
    "font-bold flex items-center gap-2 cursor-pointer text-primary1 py-4",
  saveButton:
    "h-12 px-6 flex items-center justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
};
